// Check document ready state and initialize appropriately
if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initDownloadButtons)
} else {
    initDownloadButtons()
}

// Function to initialize the download buttons logic
function initDownloadButtons() {
    let buttonsDownload = document.querySelectorAll(".download-button")

    // Exit early if no download buttons are found
    if (!buttonsDownload.length) return

    // Process each download button
    buttonsDownload.forEach((button) => {
        let linkElement = button.querySelector("a")

        // Ensure the link exists and has an href attribute
        if (linkElement) {
            let url = linkElement.getAttribute("href")
            if (url) {
                // Extract the file name from the URL and set it as the download attribute
                let downloadFilename = url.substring(url.lastIndexOf("/") + 1)
                linkElement.setAttribute("download", downloadFilename)
            }
        }
    })
}
